import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ecp-sidebar-btn-link',
  templateUrl: './sidebar-btn-link.component.html',
  styleUrls: ['./sidebar-btn-link.component.css']
})
export class SidebarBtnLinkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
